/** Hero slider — photo + ultra-slow 360° video slide, unique copy per slide. */
(function () {
  const root = document.querySelector('[data-zm-hero-slider]');
  if (!root || !root.classList.contains('zm-hero--slider')) return;

  const slides = Array.from(root.querySelectorAll('[data-zm-hero-slide]'));
  const copies = Array.from(root.querySelectorAll('[data-zm-hero-copy]'));
  const dots = Array.from(root.querySelectorAll('[data-zm-hero-dot]'));
  const prevBtn = root.querySelector('[data-zm-hero-prev]');
  const nextBtn = root.querySelector('[data-zm-hero-next]');
  const video = root.querySelector('[data-zm-hero-spin-video]');
  const spin = root.querySelector('[data-zm-hero-spin]');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (slides.length < 2) return;

  let index = 0;
  let timer = null;
  const autoplayMs = Math.max(0, parseInt(root.dataset.autoplayMs || '9000', 10) || 0);
  const SPIN_RATE = 0.45;

  if (video) {
    video.playbackRate = SPIN_RATE;
    video.defaultPlaybackRate = SPIN_RATE;
  }

  const syncVideo = (i) => {
    if (!video) return;
    const isSpin = slides[i]?.dataset.slideType === 'spin';
    video.playbackRate = SPIN_RATE;
    if (isSpin && !reduced.matches) {
      const play = video.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
    } else {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (_) {
        /* ignore */
      }
    }
  };

  const syncCopy = (i) => {
    copies.forEach((copy) => {
      const on = String(copy.dataset.copyIndex) === String(i);
      copy.classList.toggle('is-active', on);
      if (on) {
        copy.removeAttribute('hidden');
      } else {
        copy.setAttribute('hidden', '');
      }
    });
  };

  const go = (next) => {
    index = ((next % slides.length) + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      const on = i === index;
      slide.classList.toggle('is-active', on);
      slide.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
    dots.forEach((dot, i) => {
      const on = i === index;
      dot.classList.toggle('is-active', on);
      dot.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    syncCopy(index);
    syncVideo(index);
    restartTimer();
  };

  const restartTimer = () => {
    if (timer) clearInterval(timer);
    timer = null;
    if (!autoplayMs || reduced.matches) return;
    timer = setInterval(() => go(index + 1), autoplayMs);
  };

  prevBtn?.addEventListener('click', () => go(index - 1));
  nextBtn?.addEventListener('click', () => go(index + 1));
  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const i = parseInt(dot.dataset.index || '0', 10);
      go(i);
    });
  });

  root.addEventListener('mouseenter', () => {
    if (timer) clearInterval(timer);
    timer = null;
  });
  root.addEventListener('mouseleave', restartTimer);

  /* The 360° viewer owns its own drag gesture — don't also swipe the hero. */
  const insideSpin = (target) => !!(spin && target instanceof Node && spin.contains(target));

  if (spin) {
    spin.addEventListener('pointerdown', () => {
      if (timer) clearInterval(timer);
      timer = null;
    });
    spin.addEventListener('pointerup', restartTimer);
    spin.addEventListener('pointercancel', restartTimer);
  }

  let touchX = null;
  root.addEventListener(
    'touchstart',
    (e) => {
      if (insideSpin(e.target)) {
        touchX = null;
        return;
      }
      touchX = e.changedTouches[0]?.clientX ?? null;
    },
    { passive: true }
  );
  root.addEventListener(
    'touchend',
    (e) => {
      if (touchX == null) return;
      const dx = (e.changedTouches[0]?.clientX ?? touchX) - touchX;
      touchX = null;
      if (Math.abs(dx) < 48) return;
      go(index + (dx < 0 ? 1 : -1));
    },
    { passive: true }
  );

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      if (timer) clearInterval(timer);
      timer = null;
      video?.pause();
    } else {
      syncVideo(index);
      restartTimer();
    }
  });

  go(0);
})();
